const chartOptions = (sectionext, unit, reinforcement) => {
  const findMinMax = (arr, field) => {
    let min = 0;
    let max = 0;
    if (typeof arr !== 'undefined' && arr.length > 1) {
      min = Number(arr[0][field]);
      max = Number(arr[0][field]);
      for (let i = 1; i < arr.length; i += 1) {
        const v = Number(arr[i][field]);
        min = (v < min) ? v : min;
        max = (v > max) ? v : max;
      }
    }
    return [min, max];
  };

  const Xminmax = findMinMax(sectionext, 'x');
  const Yminmax = findMinMax(sectionext, 'y');
  const XRminmax = findMinMax(reinforcement, 'x');
  const YRminmax = findMinMax(reinforcement, 'y');
  const Xmin = Math.min(Xminmax[0], XRminmax[0]);
  let Xmax = Math.max(Xminmax[1], XRminmax[1]);
  const Ymin = Math.min(Yminmax[0], YRminmax[0]);
  let Ymax = Math.max(Yminmax[1], YRminmax[1]);

  const DeltaX = Xmax - Xmin;
  const DeltaY = Ymax - Ymin;

  const DeltaMax = Math.max(DeltaX, DeltaY);

  Xmax = Xmin + DeltaMax;
  Ymax = Ymin + DeltaMax;

  return {
    showLines: true,
    animation: false,
    legend: {
      display: false
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const numx = tooltipItem.xLabel.toFixed(3);
          const numy = tooltipItem.yLabel.toFixed(3);
          const dataLabel = data.datasets[tooltipItem.datasetIndex].label || '';
          const dataData = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].strain || '';
          const label = `${dataLabel}: X: ${numx} Y : ${numy}: value: ${Math.round(dataData * 1000) / 1000}`;
          return label;
        }
      }
    },
    elements: {
      point: { radius: 1 }
    },
    scales: {
      xAxes: [{
        type: 'linear',
        position: 'bottom',
        ticks: {
          min: Xmin,
          max: Xmax,
          stepSize: DeltaMax
        },
        scaleLabel: {
          display: true,
          labelString: `x(${unit.text})`
        }
      }],
      yAxes: [{
        type: 'linear',
        position: 'bottom',
        ticks: {
          min: Ymin,
          max: Ymax,
          stepSize: DeltaMax
        },
        scaleLabel: {
          display: true,
          labelString: `y(${unit.text})`
        }
      }]
    }
  };
};

export default chartOptions;
